/* blazorSuppress */
export interface IgcChatResourceStrings {
  suggestionsHeader: string;
  reactionCopy: string;
  reactionLike: string;
  reactionDislike: string;
  reactionRegenerate: string;
  attachmentLabel: string;
  attachmentsListLabel: string;
  messageCopied: string;
}

export const IgcChatResourceStringEN: IgcChatResourceStrings = {
  suggestionsHeader: 'Suggestions',
  reactionCopy: 'Copy',
  reactionLike: 'Like',
  reactionDislike: 'Dislike',
  reactionRegenerate: 'Regenerate',
  attachmentLabel: 'Attachment',
  attachmentsListLabel: 'Attachments',
  messageCopied: 'Message copied to clipboard',
};
